/* eslint-disable max-len */
import Text from '@/components/Text/Text';
import styles from './ClinicalInfoTable.module.scss';
import { mediaPath } from '@/mediaPath';
import { normalizeHtmlStyles } from '@/normalizeHtmlStyles';

interface Image {
  height: number,
  width: number,
  url: string
}

interface TableSectionContentItem {
  id: number;
  title: string;
  value: string;
}

interface TableSection {
  data: {
    __component: 'shared.table-section';
    id: number;
    title: string;
    description: string;
    backgroundImage: Image;
    content: TableSectionContentItem[];
  }
}

export function ClinicalInfoTable({ data }: TableSection) {
  const background = data.backgroundImage?.url
    ? `linear-gradient(0deg, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0.45) 100%), 
     linear-gradient(180deg, #CFB1A2 37.92%, rgba(207, 177, 162, 0.6) 151.69%), 
     url(${mediaPath(data.backgroundImage.url)}) lightgray 50% / cover no-repeat`
    : 'none';

  return (
    <section className={styles.clinicalInfo}>
      <div className={styles.textContent}>
        <Text tag='h2'>{data.title}</Text>
        <Text tag='p'>{data.description}</Text>
      </div>
      <section
        className={styles.table}
        style={{ background }}
      >
        <div className={styles.container}>
          {data.content.map((item) => (
            <div
              key={item.id}
              className={styles.row}
            >
              <div className={styles.label}>{item.title}</div>
              <div className={styles.content}>
                <div className={styles.mobileLabel}>{item.title}</div>
                <div
                  className='htmlEditorContent'
                  dangerouslySetInnerHTML={{
                    __html: normalizeHtmlStyles(item.value),
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </section>

    </section>
  );
}
